module.exports = __webpack_public_path__ + "img/valentine-modal.8416a85e.jpg";